import { configureStore } from '@reduxjs/toolkit';
import { save, load } from 'redux-localstorage-simple';
import vaultsReducer, { ListStatus } from './vaults';
import listsReducer from './lists';

const PERSISTED_KEYS: string[] = [
  "vaults.vaultsDetailsByChainID",
  "vaults.vaultsWhitelistList",
  "vaults.underlyingBalancesByAddress",
  "vaults.balancesByAddress",
];

const store = configureStore({
  reducer: {
    vaults: vaultsReducer,
    lists: listsReducer,
  },
  middleware: (getDefaultMiddleware) => 
  [
    ...getDefaultMiddleware({ serializableCheck: false }),
    save({ states: PERSISTED_KEYS, debounce: 6*1000, namespace: "arrakis-v1.0.alpha", namespaceSeparator: "::" }),
  ],
  // preloaded state overrwrites initial state
  // hence put initial state here
  preloadedState: load({ states: PERSISTED_KEYS, preloadedState: {
    vaults: {
      listStatus: ListStatus.Empty,
      vaultsDetailsByChainID: {
        [1]: {},
        [10]: {},
        [137]: {},
      },
      vaultsWhitelistList: [],
      balancesByAddress: {},
      underlyingBalancesByAddress: {}
    }
  }, namespace: "arrakis-v1", namespaceSeparator: "::" }),
})

export type AppState = ReturnType<typeof store.getState>;

export default store;